<template>
<!-- 申请列表 -->
  <div class="el-card pd20">
    <!-- 搜索---serch-box -->
    <div class="box">
      <!--  -->
      <div class="search">
        <!--  -->
        <div class="search-group">
          班级
          <el-select class="search-child"  v-model="class_name"    placeholder="请选择班级">
            <el-option v-for="(item,index) in class_name_List" :key="index" :label="item" :value="item"></el-option>
          </el-select>
        </div>
        <!--  -->
        <div class="search-group on">
          组号：
          <el-select class="search-child"  v-model="group_no"    placeholder="请选择组号">
            <el-option v-for="(item,index) in group_no_List" :key="index" :label="item" :value="item"></el-option>
          </el-select>
          <el-button style="margin-left:10px;" type="primary" @click="pullData" size="medium">搜索</el-button>
          <el-button style="margin-left:10px;" type="primary" @click="$router.push('/main/base_class_form')" size="medium">添加</el-button>
          <el-button style="margin-left:10px;" type="primary" @click="$refs.inputResult.click()" size="medium">导入</el-button>
          <input v-show="false" type="file" ref="inputResult" @change="importExcel" accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"/>
        </div>
        
      </div>
    </div>
    <div class="main">
      <div class="search-box"></div>
      <!-- list -->
      <div class="list-box">
        <el-table :data="list" show-overflow-tooltip border style="width: 100%">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column type="index" width="55" label="序号"></el-table-column>
          <el-table-column prop="group_no" label="组号（数字）"></el-table-column>
          <el-table-column prop="lf" label="促动师"></el-table-column>
          <el-table-column  width="200" label="促动师二维码（点击链接复制图片地址）">
            <template slot-scope="scope">
              <div  v-clipboard:copy="scope.row.lf_qrcode" v-clipboard:success="onCopy" v-clipboard:error="onError" title="点击复制" class="copy-link text-ellipsis">{{scope.row.lf_qrcode}}</div>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="class_name" label="班级名称"></el-table-column> -->
          

          <el-table-column prop="name" label="姓名"></el-table-column>
          <el-table-column prop="gender" label="性别"></el-table-column>
          <el-table-column  width="120" prop="phone" label="手机号"></el-table-column>
          <el-table-column  width="120" prop="email" label="邮箱账号"></el-table-column>

          <el-table-column prop="industry" label="行业"></el-table-column>
          <el-table-column prop="job" label="职业"></el-table-column>
          <el-table-column prop="province" label="省份"></el-table-column>
          <el-table-column prop="saler" label="顾问"></el-table-column>
          <!-- <el-table-column  width="200" label="课程表（点击链接复制图片地址）">
            <template slot-scope="scope">
              <div title="点击复制" v-clipboard:copy="scope.row.curriculum" v-clipboard:success="onCopy" v-clipboard:error="onError" class="copy-link text-ellipsis">{{scope.row.curriculum}}</div>
            </template>
          </el-table-column> -->
          <el-table-column prop="create_time" width="150px" label="创建时间"></el-table-column>
          <el-table-column width="180px"  label="操作">
              <template  slot-scope="scope">
                  <el-button type="primary" size="mini"  @click="updateHandle(scope.$index, scope.row)" >编辑</el-button>
                  <el-button v-if="scope.row.type!=-1" type="danger" size="mini"  @click="removeUserInfo(scope.$index, scope.row)" >删除</el-button>
              </template>
          </el-table-column>
        </el-table>
      </div>
      
      <!-- 分页 -->
      <el-pagination class="pages" 
        :page-sizes="[25, 50, 75, 100]"
        @size-change="handleSizeChange" 
        @current-change="handleCurrentChange" 
        :page-size="pages.size" 
        :current-page="pages.page"
        background 
        layout="sizes,prev, pager, next" 
        :total="pages.count"> 
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { 
  userinfoList,
  deleteUserinfo,
  addUserinfoList,
  getClassname,
  getGroupno
} from "@/api/course";
import { deepCopy,importf } from "@u/tools";
import Bus from '@u/bus'
export default {
    data() {
        return{
            list: [],
            course_name_List:[],
            group_no_List:[],
            pages: {},
            class_name:'',
            group_no:null,
            obj:{}
        }
    },
    methods:{
      onCopy: function (e) {
        this.$message.success('复制成功，直接粘贴即可！');
      },
      onError: function (e) {
        this.$message.error('复制失败，请重试！');
      },
      // 导入表格
      importExcel(){
        let that = this;
        let inputDOM = that.$refs.inputResult;
        let file = inputDOM.files;
        let h = [
            '班级名称',
            '组号',
            '姓名',
            '促动师',
            '促动师二维码',
            '性别',
            '手机号',
            '邮箱账号',
            '行业',
            '职业',
            '省份',
            '顾问',
            '课程表'
        ];
        let b =  [
          'class_name',
          'group_no',
          'name',
          'lf',
          'lf_qrcode',
          'gender',
          'phone',
          'email',
          'industry',
          'job',
          'province',
          'saler',
          'curriculum'
        ];
        // 传入表格数据，取得返回的数组
        importf(file[0],h,b,this.userTypeList,'type');
      },
      // 确认删除此用户
      removeUserInfo(index,row){
        this.$confirm('是否确认删除此用户?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$showLoading();
          deleteUserinfo({
            id:row.id
          }).then((data)=>{
            this.$hideLoading();
            if(data.error>0){
              this.$message(data.msg);
              return
            }
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
            this.pullData();
          }).catch((err)=>{
            this.$hideLoading();
          });
        });
      },
      
      // 调整每页显示条数
      handleSizeChange(val) {
          this.pages.size = val;
          this.pullData();
      },
      // 触发分页
      handleCurrentChange(val) {
          this.pages.page = val;
          this.pullData();
      },
      // 获取修改单行数据
      updateHandle(index,row){
        this.$router.push({
          path:'/main/base_class_form',
          query:{
            id:row.id
          }
        });
      },
      getListData(){
        // 获取班级列表
        getClassname().then((data)=>{
          if(data.error>0){
            this.$message(data.msg);
            return
          }
          this.class_name_List = data.list;
          this.pullData();
        });

      },
      // 初始化获取数据
      pullData(){
          this.$showLoading();

          // 获取组号列表
          getGroupno({
            class_name:this.class_name?this.class_name:this.class_name_List[0]
          }).then((data)=>{
            if(data.error>0){
              this.$message(data.msg);
              return
            }
            this.group_no_List = data.list;
          });

          let obj = {
            page:this.pages.page?this.pages.page:1,  //页码，默认1
            size:this.pages.size?this.pages.size:25   //每页数量，默认25
          };
          if(this.class_name || this.class_name_List[0]){
              obj['class_name'] = this.class_name?this.class_name:this.class_name_List[0];
              this.class_name = this.class_name?this.class_name:this.class_name_List[0];
          }

          if(this.group_no || this.group_no==0){
              obj['group_no'] = this.group_no;
          }
          this.$showLoading();
          userinfoList(obj).then((data)=>{
              if(data.error>0){
                this.$message(data.msg);
                this.$hideLoading();
                return
              }
              this.list = data.list;

              this.$hideLoading();
          }).catch((err)=>{
              this.$hideLoading();
          });

      }
    },
    created(){
        this.getListData();
        Bus.$off('importExcel'); //先解绑，不然会多次出发
        Bus.$on('importExcel',(arr)=>{
          // 批量导入添加
          this.$showLoading();
          addUserinfoList({
            list:JSON.stringify(arr)
          }).then((data)=>{
            this.$hideLoading();
            if(data.error>0){
              this.$message(data.msg);
              return
            }
            this.$message('成功'+data.success+'条，'+'失败'+data.fail+'条！');
            this.pullData();
          }).catch((err)=>{
            this.$hideLoading();
          });
        });
    }
    
}
</script>

<style lang="scss" scoped>
.main{
  position: relative;
}
.addBtn{
  position: absolute;
  left: 0;
  bottom: 0;
}
.addBtn.on{
  position: absolute;
  left: 30px;
  bottom: 0;
}
.pages{
  text-align: right;
  margin-top: 30px;
}
.box {
  margin-bottom: 20px;
}
.search {
  display: flex;
  margin-bottom: 20px;
}

.search.search-btn {
  flex: 1;
}

.search-group {
  flex: 1;
}
.search-group.on{
    flex:2;
}

.search-child {
  margin-left: 20px;
  width: 180px;
  margin-right: 40px;
}
.userinfo{
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    img{
        width: 40px;
        height: 40px;
        border-radius: 50%;
        margin-right: 15px;
    }
}
.box-card{
  margin: 0 15px 15px;
  color:#666;
  span.on{
    font-size:14px;
    color:#333;
    font-weight:bold;
  }
}
.checkBox{
  display:flex;
  align-items: center;
}
.checkBox-title{
  margin-right: 24px;
}
.demo-drawer__footer{
  display:flex;
  justify-content: space-around;
}
.copy-link{
  cursor: pointer;
}
</style>
<style lang="scss">
.el-checkbox__label{
  display:flex;
  align-items: center;
}
.el-drawer__body{
  overflow: auto;
}
</style>